import * as React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// components
import { Table } from 'components/UI'
import TableRow from '@mui/material/TableRow'
import PageLoader from 'components/UI/Loader/PageLoader'
import ActionsMenu from './components/ActionMenu'
import SyncRulesModal from 'components/Modals/SyncRulesModal'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// views
import { TableCell } from 'themes/views/tables'
// types
import { IActiveDirectory } from 'types/graphql'
// graphql
import { GET_ACTIVE_DIRECTORIES_QUERY } from 'graphql/active-directory/queries'
// utils
import get from 'lodash/get'

const headers = [
  { id: 'item.id', sortable: true, left: true, label: 'ID' },
  { id: 'item.displayName', sortable: true, left: true, label: 'NAME' },
  { id: 'actions', left: true }
]

const ActiveDirectoriesTable: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)

  const { data, loading, refetch, networkStatus } = useQuery(GET_ACTIVE_DIRECTORIES_QUERY, {
    variables: {
      pagination: {
        pageSkip: page * perPage,
        pageTake: perPage
      }
    },
    errorPolicy: 'ignore'
  })

  const isLoading = loading || networkStatus === 1
  const isRefetching = networkStatus === 2

  const activeDirectories: IActiveDirectory[] = get(data, 'activeDirectories.data', [])
  const totalCount: number = get(data, 'activeDirectories.pagination.totalCount', 0)

  if (isLoading) {
    return <PageLoader isLoading />
  }

  return (
    <>
      <Table
        page={page}
        headers={headers}
        perPage={perPage}
        refetch={refetch}
        totalCount={totalCount}
        data={activeDirectories}
        isLoading={isRefetching}
        onPageChange={handleSetPage}
        onPerPageChange={handleSetPerPage}>
        {({ data }) =>
          data.map(({ id, token, displayName }) => (
            <TableRow key={id} hover>
              <TableCell>{id}</TableCell>
              <TableCell>{displayName}</TableCell>
              <ActionsMenu token={token} />
            </TableRow>
          ))
        }
      </Table>

      <SyncRulesModal />
      <ConfirmDeleteModal header={'Delete Active Directory'}>
        Are you sure you want to delete this Active Directory?
      </ConfirmDeleteModal>
    </>
  )
}

export default ActiveDirectoriesTable
